import React from 'react';
import { Navigate , Outlet} from 'react-router-dom';

export default (props) => {
    const user = JSON.parse(localStorage.getItem('jigsawUser'))
    return (
       
            (user && user.user && user.user.role !== null)
                ? <Outlet />
                : <Navigate to='/sign-in'  />
        
    )
}